import {
    FormControl,
    FormErrorMessage,
    FormLabel,
    Input,
} from '@chakra-ui/react';

function TextField({
    label,
    isRequired = false,
    placeholder,
    field,
    form,
    type = 'text',
    isReadOnly = false,
    ...inputProps
}) {
    const isInvalid = Boolean(
        form.errors[field.name] && form.touched[field.name],
    );

    return (
        <FormControl isRequired={isRequired} isInvalid={isInvalid}>
            <FormLabel htmlFor={field.name}>{label}</FormLabel>
            <Input
                {...field}
                id={field.name}
                placeholder={placeholder}
                type={type}
                isReadOnly={isReadOnly}
                borderColor="gray.300"
                _placeholder={{ color: 'gray.400' }}
                {...inputProps}
            />
            <FormErrorMessage fontSize="sm" mt={1}>
                {form.errors[field.name]}
            </FormErrorMessage>
        </FormControl>
    );
}

export { TextField };
